module.exports = __webpack_public_path__ + "img/symbol_14.b3a5badc.png";